//REACT AND REACT BASED LIBRARIES
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
//COMPONENTS
import Table from "@components/Table";
import { Box, Container } from "@mui/material";
import AnimationFadeIn from "@components/AnimationFadeIn";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import BackgroundImage from "@components/BackgroundImageCst";
import CustomRowAction from "@components/Table/components/CustomRowAction";
//CUSTOM HOOKS AND UTILS
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { ActionsType } from "src/interfaces/Common";
import ButtonBackPage from "@components/ButtonBackPage";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";

const MultiScormTable: React.FC = () => {
  const { t } = useTranslation(["overall-page"]);
  const {
    id = "1",
    idUser,
    idActivity,
    learningObjectId,
    grandparentActivityId,
    parentActivityId,
  } = useParams();

  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${"multi-scorm.overall"}`;

  const { dataDetail: dataActivity } = useFetchDetail(
    `${ServicesURL.getActivities.replace(":idCorporate", `${id}`)}`,
    idActivity || "",
    PagesID["catalog.activities"],
  );

  const navigate = useNavigate();

  const { columns, dataTable, actionForRow } = useFetchTable(
    `${ServicesURL.scorm}?corporateId=${id}&studentId=${idUser}&activityId=${idActivity}&learningObjectId=${learningObjectId}&parentActivityId=${parentActivityId !== "null" ? parentActivityId : ""}&grandparentActivityId=${grandparentActivityId !== "null" ? grandparentActivityId : ""}`,
    PagesID["corporate.users.overall.scorm.status"],
    filters[filterId],
  );

  const configurationActionForRow: ActionsType[] = React.useMemo(() => {
    return actionForRow?.map((action: any) => {
      switch (action.type) {
        case "link": {
          return {
            ...action,
            callBack: (row: any, index: any) => {
              navigate(`change-status/${index}`);
            },
          };
        }
        default:
          return action;
      }
    });
  }, [actionForRow]);

  //FUNZIONE NECESSARIA PER APPORTARE MODIFICHE AI CAMPI DELLE AZIONI DI RIGA MA IN BASE AL VALORE DEI CAMPI (ROW)
  const customRenderRowActions = ({ row }: { row: any }): React.ReactNode => {
    let configRowNew: any = configurationActionForRow && [
      ...configurationActionForRow,
    ];

    return [
      <CustomRowAction
        key={row.id}
        row={row}
        configurationActionForRow={configRowNew}
      />,
    ];
  };

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-certificates.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${t("multi-scorm.overall.hero-title")} - ${dataActivity?.title || ""}`}
          description={t("multi-scorm.overall.hero-description")}
        />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={"multi-scorm.overall"}
            data={dataTable || []}
            columns={columns || []}
            configurationTopToolbar={[]}
            renderRowActions={customRenderRowActions}
            totalPages={dataTable?.metadata?.total_elements}
            modalTitle={
              t("multi-scorm.overall.hero-title")?.replace("-", "") || ""
            }
            hiddenFilters={true}
          />
        </Box>
      </Container>
    </AnimationFadeIn>
  );
};

export default MultiScormTable;
